/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";

const NavCardsSimpleSectionItem = (props) => {

    const item = props?.item;
    const navigate = useNavigate();

    // const guid = item?.guid;
    const nav_title = item?.nav_title;
    const banner_image = item?.banner_image;
    const path = item?.path;

    const img_url = banner_image?.image?.url;

    const handleClick = () => {
        if (path) {
            navigate(path);
        }
    };

    return (
        <Fragment>
            <div className='simplicity-nav-cards-simple-list-item'>
                <div
                    onClick={handleClick}
                    className="simplicity-nav-cards-simple-list-item-clickable"
                >
                    <div className="simplicity-nav-cards-simple-list-item-title">
                        <div className="simplicity-nav-cards-simple-card-image"
                            style={{
                                backgroundImage: `url(${img_url})`,
                            }}
                        ></div>
                        <div className="simplicity-nav-cards-simple-list-item-text">

                            <div className="simplicity-nav-cards-simple-title">
                                {nav_title}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </Fragment>
    );
};

export { NavCardsSimpleSectionItem };
